<script>
	import Icon from "../../../library/Icon.svelte";

	export let item;

	$: label = item.label;
	$: hotkey = item.hotkey;
	$: icon = item.icon;
	$: data = item.data;

</script>

<div class="wx-todo_item">
	{#if icon}
		<Icon name={icon} />
	{/if}
	<div class="wx-todo_item__label">{label}</div>
	{#if hotkey}
		<div class="wx-todo_item__hotkey">{hotkey}</div>
	{/if}
	{#if data?.length}
		<div class="wx-todo_item__sub-icon">
			<Icon name={'menu-right'} />
		</div>
	{/if}
</div>

<style>
	.wx-todo_item {
		min-width: 200px;
		max-width: 100%;
		width: 100%;

		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		padding: 8px;

		font-family: var(--wx-font-family);
		font-size: var(--wx-font-size);
		line-height: var(--wx-line-height);

		color: var(--wx-color-font);
	}
	.wx-todo_item:hover {
		background: var(--wx-background-selected);
	}
	.wx-todo_item__label {
		padding: 0 8px;
	}
	.wx-todo_item__hotkey {
		margin-left: auto;
		color: var(--wx-color-secondary-light);
	}
	.wx-todo_item__sub-icon {
		margin-left: auto;
	}

</style>
